import { ConfigService } from '@config/config.service';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { AdministratorsActions, AdministratorsActionTypes } from '@references/ngrx/actions/administrators.actions';
import { PaginationModel } from '@shared/models/pagination.model';
import {ManagerResponse} from "@services/back-office/model/managerResponse";
import {ManagerSearchRequest} from "@services/back-office/model/managerSearchRequest";

export const adapter: EntityAdapter<ManagerResponse> = createEntityAdapter<ManagerResponse>();

export interface State extends EntityState<ManagerResponse> {
  loading: boolean,
  pagination: PaginationModel,
  filter: ManagerSearchRequest,
}

export const initialState: State = adapter.getInitialState({
  loading: false,
  pagination: {
    first: true,
    last: false,
    number: 0,
    numberOfElements: 0,
    size: new ConfigService().paginationConfig.pageSize,
    totalElements: 0,
  },
  filter: {},
});

export function reducer(state = initialState, action: AdministratorsActions): State {
  switch (action.type) {
    /** Load Administrators */
    case AdministratorsActionTypes.LoadAdministrators:
      return {...state, loading: !action.payload?.dontShowLoading};

    case AdministratorsActionTypes.LoadAdministratorsSuccess:
      return adapter.setAll(action.payload.content!, {
        ...state,
        loading: false,
        pagination: {
          size: action.payload.size,
          last: action.payload.last,
          totalElements: action.payload.totalElements,
          numberOfElements: action.payload.numberOfElements,
          first: action.payload.first,
          number: action.payload.number,
        },
      });

    case AdministratorsActionTypes.LoadAdministratorsFailure:
      return {...state, loading: false};

    /** Change Page */
    case AdministratorsActionTypes.ChangePage:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          number: action.payload.number,
          size: action.payload.size,
        }
      };

    /** Set Initial Pagination */
    case AdministratorsActionTypes.SetInitialPagination:
      return {...state, pagination: initialState.pagination};

    /** Set Filter */
    case AdministratorsActionTypes.SetFilter:
      return {...state, filter: action.payload};

    /** Clear Filter */
    case AdministratorsActionTypes.ClearFilter:
      return {...state, filter: initialState.filter};

    /** Set Initial State */
    case AdministratorsActionTypes.SetInitialState:
      return {...initialState};

    default:
      return state;
  }
}

export const {
  selectIds: selectAdministratorsIds,
  selectEntities: selectAdministratorsEntities,
  selectAll: selectAllAdministrators,
  selectTotal: selectAdministratorsTotal,
} = adapter.getSelectors();
